export default "__VITE_ASSET__BiV_8AoP__"